'use client';

/** @jsxImportSource @emotion/react */
import { useTranslations } from 'next-intl';
import BringOrder from '@/components/bring-order/BringOrder';
import { ExplorePlatformButton } from '@/components';

const FrontendAssessmentSection = () => {
  const t = useTranslations('FrontendAssessmentSection');

  return (
    <BringOrder
      title={t('title')}
      description={t('description')}
      primaryBtn={t('primaryButtonLabel')}
      secondaryBtn={t('secondaryButtonLabel')}
      secondaryButton={
        <ExplorePlatformButton
          buttonText={t('secondaryButtonLabel')}
          href="/platform"
          location="frontend_assessment"
          variant="secondary"
          customStyles={{
            base: {
              color: '#000000',
              width: '100%',
            },
          }}
        />
      }
    />
  );
};

export default FrontendAssessmentSection;
